import { createContext, useContext } from 'react';

export type onCloseFunction = () => void;

export const OnClosePopoverContext = createContext<onCloseFunction | undefined>(
  undefined,
);

export const useOnClosePopoverContext = () => {
  const context = useContext(OnClosePopoverContext);
  if (!context) {
    throw new Error(
      'useOnClosePopoverContext can only be used within a OnClosePopoverContextProvider',
    );
  }
  return context;
};
